<template>
  <jw-tree-select v-model="selectVal" @change="changeSelect" :data="options" :placeholder="subcol.placeholder || $t('请选择')" :label-in-value="subcol.labelInValue || false" :allow-clear="subcol.allowClear === false ? false : true" :multiple="subcol.multiple === true ? true : false" :max-tag-count="subcol.maxTagCount === undefined ? 1 : subcol.maxTagCount" :allow-search="allowSearch" :field-names="subcol.dataProps" :tree-check-strictly="subcol.treeCheckStrictly === true ? true : false" :tree-checkable="subcol.treeCheckable === true ? true : false" :filter-tree-node="subcol.filterTreeNode || filterTreeNode" v-bind="extraAttrs" :trigger-props="{ updateAtScroll: true }" />
</template>

<script setup>
import { ref, computed, watchEffect } from 'vue';
const props = defineProps({
  subcol: {
    type: Object,
    default() {
      return {};
    }
  }
});
const emits = defineEmits(['cb']);
const selectVal = ref(props.subcol.value);
const options = computed(() => props.subcol.data || []);
// 是否允许搜索，单选默认不允许，多选默认允许，用户可以自己定义是否允许
const allowSearch = computed(() => {
  let flag = true;
  if (props.subcol.multiple) flag = true;
  else flag = false;
  if (props.subcol.allowSearch === false) flag = false;
  if (props.subcol.allowSearch === true) flag = true;
  return flag;
});

watchEffect(() => {
  options.value = props.subcol.data || [];
});
// 搜索
const filterTreeNode = (v, d) => {
  return d[props.subcol.dataProps['title'] || 'title'].toLowerCase().indexOf(v.toLowerCase()) > -1;
};

// 其他属性
const loadMore = computed(() => props.subcol.loadMore || undefined);
const extraAttrs = {
  loadMore: loadMore.value
};

// select 事件
const changeSelect = (v) => {
  const o = {};
  console.log(33, v);
  let pv = v;
  if (props.subcol.multiple) {
    if (pv.length === 0) pv = undefined;
  } else {
    if (pv === '') pv = undefined;
  }

  o[props.subcol.name] = pv;
  emits('cb', o);
};
</script>
<style scoped lang="less">
@import './xl-tree-select.less';
</style>
